"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateAst = void 0;
var uom_1 = require("uom");
var PropertyValue = __importStar(require("../property-value"));
var PropertyValueSet = __importStar(require("../property-value-set"));
var exhaustive_check_1 = require("../utils/exhaustive-check");
function evaluateAst(e, properties, matchMissingIdentifiers, comparer) {
    if (comparer === void 0) { comparer = PropertyValue.defaultComparer; }
    switch (e.type) {
        case "AndExpr": {
            for (var _i = 0, _a = e.children; _i < _a.length; _i++) {
                var child = _a[_i];
                if (!evaluateAst(child, properties, matchMissingIdentifiers, comparer)) {
                    return false;
                }
            }
            return true;
        }
        case "OrExpr": {
            for (var _b = 0, _c = e.children; _b < _c.length; _b++) {
                var child = _c[_b];
                if (evaluateAst(child, properties, matchMissingIdentifiers, comparer)) {
                    return true;
                }
            }
            return false;
        }
        case "EqualsExpr": {
            // Handle match missing identifier
            if (matchMissingIdentifiers) {
                if (_isMissingIdent(e.leftValue, properties) ||
                    e.rightValueRanges.filter(function (vr) { return _isMissingIdent(vr.min, properties) || _isMissingIdent(vr.max, properties); }).length > 0) {
                    return true;
                }
            }
            var left = evaluatePropertyValueExpr(e.leftValue, properties);
            for (var _d = 0, _e = e.rightValueRanges; _d < _e.length; _d++) {
                var range = _e[_d];
                var min = evaluatePropertyValueExpr(range.min, properties);
                var max = evaluatePropertyValueExpr(range.max, properties);
                // Match on NULL or inclusive in range
                if (((max === null || min === null) && left === null) ||
                    (left !== null &&
                        min !== null &&
                        max !== null &&
                        PropertyValue.greaterOrEqualTo(left, min, comparer) &&
                        PropertyValue.lessOrEqualTo(left, max, comparer))) {
                    return e.operationType === "equals";
                }
            }
            return e.operationType === "notEquals";
        }
        case "ComparisonExpr": {
            // Handle match missing identifier
            if (matchMissingIdentifiers &&
                (_isMissingIdent(e.leftValue, properties) || _isMissingIdent(e.rightValue, properties))) {
                return true;
            }
            var left = evaluatePropertyValueExpr(e.leftValue, properties);
            if (left === null) {
                return false;
            }
            var right = evaluatePropertyValueExpr(e.rightValue, properties);
            if (right === null) {
                return false;
            }
            switch (e.operationType) {
                case "less":
                    return PropertyValue.lessThan(left, right, comparer);
                case "greater":
                    return PropertyValue.greaterThan(left, right, comparer);
                case "lessOrEqual":
                    return PropertyValue.lessOrEqualTo(left, right, comparer);
                case "greaterOrEqual":
                    return PropertyValue.greaterOrEqualTo(left, right, comparer);
                default:
                    throw new Error("Unknown comparisontype");
            }
        }
        case "EmptyExpr": {
            return true;
        }
        default: {
            return exhaustive_check_1.exhaustiveCheck(e, true);
        }
    }
}
exports.evaluateAst = evaluateAst;
function evaluatePropertyValueExpr(e, properties) {
    switch (e.type) {
        case "IdentifierExpr": {
            var pv = PropertyValueSet.get(e.name, properties);
            return pv || null;
        }
        case "ValueExpr": {
            return e.parsed;
        }
        case "NullExpr": {
            return null;
        }
        case "AddExpr": {
            var left = evaluatePropertyValueExpr(e.left, properties);
            var right = evaluatePropertyValueExpr(e.right, properties);
            if (!left) {
                return right;
            }
            if (!right) {
                return left;
            }
            if (left.type === "integer" && right.type === "integer") {
                if (e.operationType === "add") {
                    return PropertyValue.fromInteger(left.value + right.value);
                }
                else {
                    return PropertyValue.fromInteger(left.value - right.value);
                }
            }
            else if (left.type === "text" && right.type === "text") {
                if (e.operationType === "add") {
                    return PropertyValue.fromText(left.value + right.value);
                }
                else {
                    return null;
                }
            }
            else if (left.type === "amount" && right.type === "amount") {
                if (e.operationType === "add") {
                    return PropertyValue.fromAmount(uom_1.Amount.plus(left.value, right.value));
                }
                else {
                    return PropertyValue.fromAmount(uom_1.Amount.minus(left.value, right.value));
                }
            }
            return null;
        }
        case "MulExpr": {
            var left = evaluatePropertyValueExpr(e.left, properties);
            var right = evaluatePropertyValueExpr(e.right, properties);
            if (!left || !right) {
                return null;
            }
            if (left.type === "integer" && right.type === "integer") {
                if (e.operationType === "multiply") {
                    return PropertyValue.fromInteger(left.value * right.value);
                }
                else {
                    return PropertyValue.fromInteger(left.value / right.value);
                }
            }
            else if (left.type === "amount" && right.type === "integer") {
                if (e.operationType === "multiply") {
                    return PropertyValue.fromAmount(uom_1.Amount.times(left.value, right.value));
                }
                else {
                    return PropertyValue.fromAmount(uom_1.Amount.divide(left.value, right.value));
                }
            }
            else if (left.type === "integer" && right.type === "amount") {
                if (e.operationType === "multiply") {
                    return PropertyValue.fromAmount(uom_1.Amount.times(right.value, left.value));
                }
            }
            return null;
        }
        case "UnaryExpr": {
            var value = evaluatePropertyValueExpr(e.value, properties);
            if (!value || value.type === "text") {
                return null;
            }
            if (value.type === "integer") {
                return PropertyValue.fromInteger(-value.value);
            }
            else {
                return PropertyValue.fromAmount(uom_1.Amount.neg(value.value));
            }
        }
        default: {
            return exhaustive_check_1.exhaustiveCheck(e, true);
        }
    }
}
function _isMissingIdent(e, properties) {
    // If expression is an missing identifier it should match anything
    if (e.type === "IdentifierExpr") {
        if (!PropertyValueSet.hasProperty(e.name, properties)) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=evaluate-ast.js.map